import { render, staticRenderFns } from "./HeadingPrice.vue?vue&type=template&id=25721b19&scoped=true"
import script from "./HeadingPrice.vue?vue&type=script&lang=js"
export * from "./HeadingPrice.vue?vue&type=script&lang=js"
import style0 from "./HeadingPrice.vue?vue&type=style&index=0&id=25721b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25721b19",
  null
  
)

export default component.exports